<div class="position-relative">
    <div class="glaeSegmentHeader" [ngClass]="isCxone ? 'legacy-styles-section' : 'glaeSegmentHeader'" cvLocalizedText langSection="Games" langKey="Eligibility_Title">Eligibility</div>
    <div class="glaeSegmentText" [ngClass]="{'legacy-styles-sub-section': isCxone}" *ngIf="gs.modified.item.underlyingRule.Category != 3" cvLocalizedText
        langSection="Games" langKey="Eligibility_Brackets_Help">Select the group of participants who will be invited to
        join the game. Players are automatically added to the game.</div>
    <div class="glaeSegmentText" *ngIf="gs.modified.item.underlyingRule.Category == 3">
        {{getEligibilityDescription(secondLevelName)}}</div>

    <div class="font-size-14 lato-bold mt-3 mb-3 brackets-eligibility-description"
        *ngIf="gs.modified.item.underlyingRule.Category != 3" cvLocalizedText langSection="Games"
        langKey="Select_Rounds">Amount of Rounds</div>

    <div>
        <select class="form-control select-rounds" [disabled]="gameStarted && !gs.modified.item.underlyingRule.IsCopy"
            [(ngModel)]="gs.modified.item?.BracketTournamentDetails.NumberOfRounds"
            (ngModelChange)="updateTotalParticipants($event)">
            <option *ngFor="let option of rounds" [value]="option">{{option}}</option>
        </select>
    </div>

    <div class="font-size-14 lato-bold mt-3 mb-1 brackets-eligibility-description"
        *ngIf="gs.modified.item.underlyingRule.Category != 3" cvLocalizedText langSection="Games"
        langKey="Players_Distribution">Players Distribution</div>
    <div class="glaeSegmentText mb-1" *ngIf="gs.modified.item.underlyingRule.Category != 3" cvLocalizedText
        langSection="Games" langKey="Players_Distribution_Description_Line1">In Ranked mode, players are matched by 
        performance, pairing the highest with the lowest and continuing in order. Rankings are applied after metric selection.</div>
    <div class="glaeSegmentText" *ngIf="gs.modified.item.underlyingRule.Category != 3" cvLocalizedText
        langSection="Games" langKey="Players_Distribution_Description_Line2">Randomized mode will structure/pair matches randomly 
        based on your selection.</div>

    <div class="d-flex flex-row align-items-center mt-2">
        <div class="form-check pr-5">
            <input type="radio" class="form-check-input radio-rank" [name]="'rank'" (change)="onRankedChange()"
                [(ngModel)]="gs.modified.item.BracketTournamentDetails.isRanked" [value]="true"
                [disabled]="gameStarted && !gs.modified.item.underlyingRule.IsCopy" />
            <label for="eligibilityType" class="form-check-label font-size-13 color-whaleTail font-weight-bold pr-2"
                cvLocalizedText langSection="Games" langKey="Group_Selection_Ranked">Ranked</label>
        </div>
        <div>
            <input type="radio" class="form-check-input radio-random" [name]="'random'" (change)="onRankedChange()"
                [(ngModel)]="gs.modified.item.BracketTournamentDetails.isRanked" [value]="false"
                [disabled]="gameStarted && !gs.modified.item.underlyingRule.IsCopy" />
            <label for="eligibilityType" class="form-check-label font-size-13 color-whaleTail font-weight-bold pr-2"
                cvLocalizedText langSection="Games" langKey="Group_Selection_Randomized">Randomized</label>
        </div>
    </div>

    <div class="mt-2 mb-1"
        *ngIf="(gs.modified.item.Eligibility?.AssignedGroups?.emp || []).length > 0 || this.totalParticipants >= 0">
        <div class="glaeSegmentText participantsText font-size-14">
            {{ gs.modified.item.Eligibility?.AssignedGroups?.emp?.length }}/{{ this.totalParticipants }}
            <span cvLocalizedText langSection="Games" langKey="Participants">Participants</span>
        </div>
    </div>
    <!-- EMPGROUP -->
    <div class="glaeGroupList p-2 mt-2 rounded">
        <div class="d-flex flex-row pt-1">
            <div class="d-flex flex-row align-items-center ml-auto pr-1">
                <div *ngIf="!gameStarted || gs.modified.item.underlyingRule.IsCopy" class="d-flex">
                    <div class="wallboardTooltipIcon position-relative deleteSelection"
                        (click)="deleteSelection('emp')">
                        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-cerulean p-0">
                            <svg class="icon-16">
                                <use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use>
                            </svg>
                        </button>
                        <div class="font-size-12 d-none px-1 border border-secondary position-absolute"
                            style="top:-21px; right:0px; white-space:nowrap; max-width:none; background-color:#FDFCF5; pointer-events:none; z-index:1; line-height:21px;"
                            cvLocalizedText langSection="Games" langKey="Delete_Groups">Delete All</div>
                    </div>
                    <div class="wallboardTooltipIcon position-relative pl-2" (click)="setAssignToolData()">
                        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-cerulean p-0">
                            <svg class="icon-16">
                                <use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use>
                            </svg>
                        </button>
                        <div class="font-size-12 d-none px-1 border border-secondary position-absolute"
                            style="top:-21px; left:8px; white-space:nowrap; max-width:none; background-color:#FDFCF5; pointer-events:none; z-index:1; line-height:21px;"
                            cvLocalizedText langSection="Games" langKey="Edit_Group">Edit Group</div>
                    </div>
                </div>
                <div class="expandedView wallboardTooltipIcon position-relative ml-1"
                    (click)="openExpandedView($event)">
                    <button type="button" class="icon-btn fill-valyrianSteel fill-hover-cerulean p-0">
                        <svg class="icon-16">
                            <use href="../App_Themes/clearview-default/icons/utility/expand.svg#expand"></use>
                        </svg>
                    </button>
                    <div class="font-size-12 d-none px-1 border border-secondary position-absolute"
                        style="top:-21px; right:0px; white-space:nowrap; max-width:none; background-color:#FDFCF5; pointer-events:none; z-index:1; line-height:21px;"
                        cvLocalizedText langSection="Games" langKey="Expand_View">Expand View</div>
                </div>
            </div>
        </div>
        <!-- Brackets diagram -->
        <div class="brackets-container">
            <cv-bracket-view
                [data]="gs.modified.item.BracketTournamentMatches.length > 0 ? gs.modified.item.BracketTournamentMatches : pairs"
                [numberOfRounds]="gs.modified.item.BracketTournamentDetails.NumberOfRounds"
                [isNewGame]="gs.modified.item.underlyingRule.RuleID ===0" [loading]="loading"
                [gameStarted]="gs.modified.item.BracketTournamentDetails.GameStarted"></cv-bracket-view>
        </div>
    </div>

    <div *ngIf="isButtonVisible()">
        <button type="button" class="btn btn-text btn-icon mt-3" style="transition: none;"
            *ngIf="(gs.modified.item.Eligibility == undefined || gs.modified.item.Eligibility.AssignedGroups == null || gs.modified.item.Eligibility.AssignedGroups.emp == null || gs.modified.item.Eligibility.AssignedGroups.rec == null || gs.modified.item.Eligibility.AssignedGroups.emp.length == 0 || gs.modified.item.Eligibility.AssignedGroups.rec.length == 0)"
            (click)="setAssignToolData()">
            <svg class="icon-16 fill-cerulean">
                <use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use>
            </svg>
            <span cvLocalizedText id="btnChooseGameParticipants" *ngIf="gs.modified.item.underlyingRule.Category != 3"
                langSection="Games" langKey="Choose_Game_Participants">Add Participants</span>
            <span id="btnChooseGameTeams" [ngClass]="{ 'legacy-styles-body': isCxone }" *ngIf="gs.modified.item.underlyingRule.Category == 3">
                <span cvLocalizedText langSection="Common" langKey="Add" [ngClass]="{ 'legacy-styles-body': isCxone }">Add</span> {{ secondLevelName }}
            </span>
        </button>
    </div>
</div>

<cv-angular-assign-tool *ngIf="gs.modified.item.underlyingRule.Category != 3" [retainSelected]="true" showTypes="emp"
    [showAll]="true" [singleAdd]="false" [singleType]="true" [showParent]="true"
    [headerText]="getLocalizedMessage('Assign_Groups', 'Assign Groups')"
    [buttonText]="getLocalizedMessage('Assign_Button', 'Assign')" type="gamesAddEdit" [(showPopup)]="assignToolVisible"
    [(dataTransfer)]="assignedGroups" [limitOfParticipants]="totalParticipants"
    (dataTransferChange)="onAssignToolSave($event)" [gameType]="gameType">
</cv-angular-assign-tool>

<div class="modal-container" *ngIf="isExpandedView" (click)="closeExpandedView($event)">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <div class="maDetailsPopupClose close-modal show-on-load close-container btn-close"
                (click)="closeExpandedView($event)"></div>
            <div>
                <span class="bracket-title">{{gs.modified.item.underlyingRule.RuleName}}</span>
                <div *ngIf="metricName">
                    <span class="metric-name" [ngClass]="{ 'legacy-styles-body': isCxone }" cvLocalizedText langSection="Games" langKey="Metric">Metric</span> :
                    {{metricName}}
                </div>
            </div>
        </div>
        <hr class="modal-divider" />
        <cv-bracket-view
            [data]="gs.modified.item.BracketTournamentMatches.length > 0 ? gs.modified.item.BracketTournamentMatches : pairs"
            [numberOfRounds]="gs.modified.item.BracketTournamentDetails.NumberOfRounds"
            [isNewGame]="gs.modified.item.underlyingRule.RuleID ===0" [loading]="loading"
            [gameStarted]="gs.modified.item.BracketTournamentDetails.GameStarted">
        </cv-bracket-view>
        <div class="cv-loader-container">
            <cv-loader size="medium" [overlay]="true" *ngIf="loading">
            </cv-loader>
        </div>
    </div>
</div>
